module.exports = __webpack_public_path__ + "static/media/twitter.ce269506.svg";